export default function Typography() {
  return {}
}
